module.exports = __webpack_public_path__ + "static/media/questionAnswerDefault.8a58ff61.svg";